import { useState, useLayoutEffect } from 'react';
import { debounce } from 'throttle-debounce';
import { isClient } from '../../private/helpers/isClient';

export const useWindowSize = (interval = 0): { width: number; height: number } => {
  const [dimensions, setDimensions] = useState({
    width: isClient() ? window.innerWidth : 0,
    height: isClient() ? window.innerHeight : 0,
  });

  useLayoutEffect(() => {
    const handleResize = debounce(interval, () =>
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      }),
    ) as EventListener;

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [interval]);

  return dimensions;
};
